<script>
/* eslint-disable vue/require-v-for-key */
export default {
    name: "AgesSelect",
    props: {
        // eslint-disable-next-line vue/require-prop-type-constructor
        hideLabel: false,
        labelText: {
            type: String,
            default: "Participants ages",
        },
        default: {
            type: Array,
            default: () => [],
        },
        uniqKey: {
            type: Number,
            default: 0,
        },
        error: {
            type: String,
        },
        disabled: {
            type: Boolean,
            default() {
                return false;
            },
        },
    },
    data() {
        return {
            ages: [
                { id: 200, name: "0-6m" },
                { id: 201, name: "6-12m" },
                { id: 1, name: "1", selected: "" },
                { id: 2, name: "2" },
                { id: 3, name: "3" },
                { id: 4, name: "4" },
                { id: 5, name: "5" },
                { id: 6, name: "6" },
                { id: 7, name: "7" },
                { id: 8, name: "8" },
                { id: 9, name: "9" },
                { id: 10, name: "10" },
                { id: 11, name: "11" },
                { id: 12, name: "12" },
                { id: 13, name: "13" },
                { id: 14, name: "14" },
                { id: 15, name: "15" },
                { id: 16, name: "16" },
                { id: 17, name: "17" },
                { id: 127, name: "18+" },
                { id: 255, name: "Pregnancy" },
            ],
            selectedAges: [],
            showAgesContainer: false,
            idElementToIgnore: `age-selector-${this.uniqKey}`,
        };
    },
    methods: {
        toggle(age) {
            // add category to array or remove if its already in
            const foundAge = this.selectedAges.filter((el) => el.id === age.id);
            if (foundAge.length === 0) {
                this.selectedAges.push(age);
                this.ages[this.ages.findIndex((el) => el.id === age.id)].selected = true;
            }
            if (foundAge.length > 0) {
                this.selectedAges.splice(
                    this.selectedAges.findIndex((el) => el.id === age.id),
                    1,
                );
                this.ages[this.ages.findIndex((el) => el.id === age.id)].selected = false;
            }

            this.$emit("update", this.selectedAges);
        },
        isCurrentAgeSelected(age) {
            return this.selectedAges.filter((el) => el.id === age.id).length;
        },
        clickOutsideAgesValues() {
            this.showAgesContainer = false;
        },
    },
    computed: {
        selectedCategoryNames() {
            const names = this.selectedAges.map((el) => el.name);
            return names.join(", ");
        },
    },
    watch: {
        default: {
            handler() {
                this.selectedAges = this.default.map((age) => ({
                    ...age,
                    id: Number.parseInt(age.id, 10),
                    selected: true,
                }));
            },
            deep: true,
        },
    },
    mounted() {
        this.selectedAges = this.default;
    },
};
</script>

<template>
    <div class="ages-select position-relative">
        <label v-if="!hideLabel" :class="{ show: selectedAges.length > 0 }">{{ labelText }}</label>
        <input
            :disabled="disabled"
            @click="showAgesContainer = !showAgesContainer"
            data-test="select-ages"
            class="w-100 text"
            :class="{
                'error-input-border-rounded': (props?.error) ? true : false
            }"
            :id="'age-selector-' + uniqKey"
            v-model="selectedCategoryNames"
            type="text"
            readonly
            placeholder="Choose an age"
        />
        <div class="reverse" :class="{ arrow: !hideLabel, 'arrow-without-label': hideLabel }">
            <svg
                class="animate"
                :class="{ 'animate-open': showAgesContainer }"
                width="19"
                height="19"
                viewBox="0 0 19 19"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <path
                    d="M3.63695 7.05328L8.8241 13.1066C8.90771 13.2041 9.01142 13.2824 9.12813 13.336C9.24484 13.3897 9.37177 13.4175 9.50023 13.4175C9.62868 13.4175 9.75562 13.3897 9.87233 13.336C9.98903 13.2824 10.0927 13.2041 10.1764 13.1066L15.3635 7.05328C15.8585 6.47549 15.4481 5.58301 14.6874 5.58301H4.3116C3.55086 5.58301 3.14043 6.47549 3.63695 7.05328V7.05328Z"
                    fill="#FFB700"
                />
            </svg>
        </div>

        <div
            v-click-outside:[idElementToIgnore]="clickOutsideAgesValues"
            v-show="showAgesContainer"
            class="ages-container"
            data-test="select-ages-popover"
            id="custom-select-ages-values"
        >
            <div
                v-for="age in ages"
                class="age-item"
                :data-test="`select-ages-popover-${age.name}`"
                @click="toggle(age)"
                :class="{ selected: isCurrentAgeSelected(age) }"
            >
                {{ age.name }}
            </div>
        </div>
    </div>
</template>

<style scoped>

.error-input-border-rounded {
    border: 1px solid #fb0100 !important;
    border-radius: 10px;
}

.arrow {
    position: absolute;
    top: 38px;
    right: 12px;
}

.reverse {
    pointer-events: none;
}

.animate {
    transition: transform 0.15s cubic-bezier(1, 0.5, 0.8, 1);
    transition-timing-function: cubic-bezier(1, 0.5, 0.8, 1);
}

.animate-open {
    transform: rotate(180deg);
}

.arrow-without-label {
    position: absolute;
    top: 14px;
    right: 12px;
}

.ages-container {
    display: flex;
    flex-direction: row;
    flex-wrap: wrap;
    align-items: flex-start;
    padding: 8px;
    position: absolute;
    min-width: 459px;
    max-width: 459px;
    min-height: 134px;
    background: #ffffff;
    border: 1px solid #dddddd;
    box-sizing: border-box;
    box-shadow: 5px 5px 10px rgba(0, 0, 0, 0.1);
    border-radius: 10px;
    margin-top: 3px;
    z-index: 3;
}

.ages-container .age-item {
    background: #ffffff;
    padding: 5px 13px;
    border: 1px solid #272529;
    box-sizing: border-box;
    border-radius: 17px;
    flex: none;
    order: 3;
    flex-grow: 0;
    margin: 0px 8px;
    cursor: pointer;
}

.ages-container .age-item.selected {
    background: #260045;
    color: #fff;
}

input::placeholder {
    color: #999999;
}
</style>
